module.exports = __webpack_public_path__ + "static/img/function-box-img3.b4bdb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/function-box-img3.png
// module id = lEWg
// module chunks = 0